import React, { useEffect } from 'react';

const RecruitPage = () => {
  // ページ表示前にリダイレクト処理を実行
  if (typeof window !== "undefined") {
    window.location.href = "https://arwrk.net/recruit/hhc5p8u69gcdhd1";
    return null; // 何もレンダリングしない
  }

  return null;
};

export default RecruitPage;